import { useEffect, useState } from "react";
import getCookie from "utils/customFunctions";

const ISU_ORIGIN = "https://backend-isu.gstou.ru";

export const fetchIsuUser = async () => {
  const token = getCookie("token");
  if (!token) return null;

  try {
    const response = await fetch(`${ISU_ORIGIN}/o/userinfo/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) return null;

    const data = await response.json();
    return {
      username: data.preferred_username || "",
      fullName: data.name || "",
    };
  } catch (e) {
    // Сеть недоступна — шапка просто не покажет имя, ломать её незачем.
    return null;
  }
};

export const useIsuUser = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetchIsuUser().then((value) => {
      if (!cancelled) setUser(value);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return user;
};

export default useIsuUser;
